module.exports = __webpack_public_path__ + "static/media/icon-header-project.f952032c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/HeaderNoLogout/assets/icon-header-project.svg
// module id = 1849
// module chunks = 193